import { post } from '@/utils/request';
import type { IEnterpriseCertification } from './interface';
import i18n from '@/i18n';

// 获取认证链接
const getCertificationLink = (
  params: IEnterpriseCertification.Request.GetCertificationLinkParams,
) => {
  return post<IEnterpriseCertification.Response.GetCertificationLinkRes>(
    'user/get_sign_certification_link',
    params,
    i18n.t('failed_to_obtain_the_authentication_link'),
    undefined,
    {
      isCamel: false,
      isLower: false,
    },
  );
};

export { getCertificationLink };
